import {ActionService, ConfigurationService, JwtHttpClientService, ResourceModule} from "@fedeltapointofsale/data-client";
import {Inject, Injectable} from "@angular/core";

export class DocketPrinterDownloadQueueStatsAction {
    constructor(public id: number) {
    }
}

@Injectable()
export class DocketQueueStatsDownloadService extends ActionService {
    constructor(http: JwtHttpClientService,
                configService: ConfigurationService,
                @Inject(ResourceModule.RESOURCE_NAMESPACE_KEY) nameSpace,
                @Inject(ResourceModule.ACTION_NAMES_KEY) actionNames) {
        super(http, configService, nameSpace, actionNames, "docket-queue-stats-download");
    }
}
